'use client';
import React from 'react';
import { Tabs } from '@benzinga/core-ui';
import styled from '@benzinga/themetron';

import { InputGroup } from '../InputGroup';

import { Option } from '../../entities';

interface SingleSelectGroupProps {
  label: string;
  options: Option[];
  onChange: (selected: Option) => void;
  selected: Option;
}

export const SingleSelectGroup: React.FC<SingleSelectGroupProps> = ({ label, onChange, options, selected }) => {
  const tabs = options.map((o: Option) => {
    return { key: o.value as string, name: o.label };
  });
  const handleTabChange = React.useCallback(
    (key: string) => {
      const r = options.filter(o => o.value === key).pop();
      if (r) onChange(r);
    },
    [options, onChange],
  );
  return (
    <SingleSelectGroupWrapper className="input-group">
      <label>{label}</label>
      <Tabs activeTab={selected.value as string} onChange={handleTabChange} tabs={tabs} />
    </SingleSelectGroupWrapper>
  );
};

export const SingleSelectGroupWrapper = styled(InputGroup)`
  .tabs-container .tab-list {
    margin: 0;
    overflow-x: auto;
    border: solid 1px #ddd;
    .tab {
      display: flex;
      align-items: center;
      width: 100%;
      height: 50px;
      justify-content: center;
      background-color: #e5e5e5;
      border-right: solid 1px #ddd;
      margin-right: 0;
      font-size: ${({ theme }) => theme.fontSize.sm};
      font-weight: ${({ theme }) => theme.fontWeight.normal};
      padding: 8px;

      &:nth-of-type(1) {
        border-top-left-radius: ${({ theme }) => theme.borderRadius.sm};
        border-bottom-left-radius: ${({ theme }) => theme.borderRadius.sm};
      }

      &:nth-of-type(2) {
        border-top-right-radius: ${({ theme }) => theme.borderRadius.sm};
        border-bottom-right-radius: ${({ theme }) => theme.borderRadius.sm};
      }

      &:last-of-type {
        border-right: none;
      }

      &:hover {
        color: ${({ theme }) => theme.colorPalette.gray500};
      }

      &.selected {
        background-color: #e8743e;
        color: #ffffff;

        > span {
          color: #ffffff;
        }
      }

      > span {
        margin-right: 5px;
        font-size: ${({ theme }) => theme.fontSize.xl};
      }

      @media screen and (min-width: 800px) {
        background-color: transparent;
        height: auto;

        &:nth-of-type(1),
        &:nth-of-type(2) {
          border-radius: none;
        }

        &.selected {
          background-color: transparent;
          color: #242429;

          > span {
            color: ${({ theme }) => theme.colorPalette.blue500};
          }
        }
      }
    }
  }
`;
